// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__1DNsn","item":"PaymentsMobile_item__DnOdX","label":"PaymentsMobile_label__1YjKH","amount":"PaymentsMobile_amount__l1552"};